import { Component } from '@angular/core';
import { StoreService } from 'avn/modules/services/store.service';
import { Location } from 'avn/modules/shared/interfaces/homepage';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.html',
  styleUrls: ['./not-found.scss']
})
export class NotFoundComponent {
  public constructor(private readonly store: StoreService) {}

  public getWellbeingURL(): string[] {
    const location = this.store.meraLocation as Location;
    return [
      `/search/health-and-wellbeing-services/${location.city_name.toLowerCase().replace(/ /g, '-')}/${
        location.post_code
      }`
    ];
  }
}
